<script>
export default {
  name: 'SvgIconInline',
  props: {
    name: {
      type: String,
      default: '',
    },
  },
  data() {
    return {};
  },
  computed: {
    w() {
      const { sizes, name } = this;

      if (!sizes || !name || !sizes[name]) return 14;

      const result = sizes[name][0];

      return result;
    },
    h() {
      const { sizes, name } = this;

      if (!sizes || !name || !sizes[name]) return 14;

      const result = sizes[name][1];

      return result;
    },
  },
  created() {
    this.sizes = {
      facebook: [7, 13],
      telegram: [14, 12],
      youtube: [14, 10],
      twitter: [14, 11],
      medium: [14, 11],
      discord: [16, 11],
    };
  },
  mounted() {},
  methods: {},
};
</script>

<template>
  <div>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      :width="w"
      :height="h"
      :viewBox="`0 0 ${w} ${h}`"
      :class="['icon', `${name}`]"
    >
      <defs>
        <!-- local -->
        <path
          id="prefix__a"
          d="M0.005 0.003L13.333 0.003 13.333 9.394 0.005 9.394z"
        />

        <!-- telegram -->
        <g id="telegram" v-if="name === 'telegram'">
          <path
            d="M.569 5.76L3.64 6.914l1.19 3.844c.075.246.375.337.574.173l1.712-1.403c.18-.147.435-.154.623-.017l3.089 2.253c.212.156.514.039.567-.22L13.66.605c.058-.282-.218-.517-.485-.413L.565 5.08c-.31.12-.308.563.004.68zm4.07.54l6.004-3.717c.108-.066.219.08.126.167L5.814 7.379c-.174.163-.287.38-.318.617l-.17 1.258c-.022.167-.256.184-.302.022l-.65-2.293c-.074-.261.034-.54.265-.683z"
          />
        </g>

        <!-- facebook -->
        <g id="facebook" v-if="name === 'facebook'">
          <path
            d="M6.713.003L5.043 0c-1.877 0-3.09 1.244-3.09 3.17v1.462H.273c-.145 0-.263.118-.263.263v2.118c0 .145.118.263.263.263h1.68v5.344c0 .145.117.262.262.262h2.192c.145 0 .263-.117.263-.262V7.276h1.963c.146 0 .263-.118.263-.263l.001-2.118c0-.07-.028-.136-.077-.186-.05-.05-.116-.077-.186-.077H4.67V3.393c0-.596.141-.898.917-.898h1.126c.145 0 .262-.118.262-.263V.265c0-.145-.117-.262-.262-.262z"
          />
        </g>

        <!-- youtube -->
        <g
          id="youtube"
          v-if="name === 'youtube'"
          fill-rule="evenodd"
          transform="translate(.333)"
        >
          <path
            d="M6.961.001c.97.006 4.043.044 4.915.28.574.154 1.025.608 1.179 1.186.278 1.046.278 3.23.278 3.23v.011c0 .169-.011 2.216-.278 3.22-.154.576-.605 1.031-1.18 1.186-.905.244-4.184.275-5.016.28h-.385c-.831-.005-4.111-.036-5.017-.28C.884 8.959.432 8.504.28 7.927.023 6.967.002 5.053 0 4.741v-.088c.002-.312.023-2.227.279-3.186C.432.889.884.435 1.457.28 2.33.045 5.403.007 6.372.001zM5.303 2.714V6.68l3.485-1.982-3.485-1.983z"
            mask="url(#prefix__b)"
          />
        </g>

        <!-- twitter -->
        <g id="twitter" v-if="name === 'twitter'">
          <path
            fill-rule="evenodd"
            d="M12.302 2.699c.005.117.008.235.008.353 0 3.614-2.752 7.781-7.783 7.781-1.545 0-2.983-.452-4.194-1.228.214.025.432.038.653.038 1.282 0 2.461-.437 3.398-1.171-1.198-.022-2.208-.813-2.556-1.9.167.032.338.05.514.05.25 0 .492-.034.721-.096C1.812 6.275.87 5.169.87 3.845V3.81c.369.205.79.328 1.24.342C1.373 3.662.89 2.824.89 1.875c0-.5.135-.97.37-1.374C2.611 2.156 4.626 3.244 6.9 3.358c-.047-.2-.071-.409-.071-.623C6.829 1.225 8.054 0 9.565 0c.787 0 1.497.333 1.997.864.623-.123 1.208-.35 1.737-.664-.205.639-.638 1.174-1.203 1.513.553-.066 1.08-.213 1.57-.43-.365.548-.83 1.03-1.364 1.416z"
          />
        </g>

        <!-- medium -->
        <g id="medium" v-if="name === 'medium'">
          <path
            d="M1.914 2.21c.017-.168-.045-.333-.168-.446L.501.23V0h3.866l2.988 6.706L9.982 0h3.685v.23l-1.065 1.044c-.092.071-.137.189-.118.305v7.675c-.019.116.026.234.118.306l1.04 1.044v.23H8.413v-.23l1.077-1.07c.106-.108.106-.14.106-.306V3.025l-2.994 7.783h-.405L2.711 3.025v5.216c-.029.22.042.44.193.599l1.4 1.739v.229H.335v-.23l1.4-1.738c.15-.159.217-.381.18-.599V2.21z"
          />
        </g>

        <!-- discord -->
        <g id="discord" v-if="name === 'discord'">
          <path
            d="M5.83.06l.147.145C3.585.775 2.5 1.845 2.5 1.845s.29-.143.797-.36c3.222-1.266 6.74-1.175 9.998.43 0 0-1.086-1-3.332-1.64l.199-.195c.31.001 1.953.059 3.71 1.344 0 0 1.967 3.36 1.967 7.488-.065-.079-1.22 1.777-4.193 1.841 0 0-.503-.57-.861-1.067 1.738-.499 2.389-1.497 2.389-1.497-.57.36-1.091.573-1.514.786-.65.286-1.3.427-1.95.57-3.076.5-4.803-.335-6.435-.998l-.558-.284s.65.999 2.32 1.498c-.44.5-.873 1.069-.873 1.069C1.192 10.76.108 8.903.108 8.903c0-4.134 1.955-7.488 1.955-7.488C4.02-.007 5.831.061 5.831.061zm4.565 4.71v.002c-.755 0-1.374.638-1.376 1.427 0 .783.618 1.423 1.376 1.423.759 0 1.376-.64 1.376-1.429 0-.784-.614-1.424-1.376-1.424zm-4.921 0l-.005.002c-.758 0-1.376.638-1.376 1.427 0 .783.618 1.423 1.376 1.423.759 0 1.376-.64 1.376-1.429 0-.784-.613-1.424-1.371-1.424z"
          />
        </g>
      </defs>

      <!--  -->
      <use :href="`#${name}`" x="0" y="0" :width="w" :height="h" />
    </svg>
  </div>
</template>

<style scoped lang="scss"></style>
